import React from 'react';
import '../../../Styles/Layout/Input-Area/QuotedContentDisplay.css';
import { useChatContext } from '../../../contexts/AppDataContext';
import { ArrowMoveDownRightIcon, Cancel01Icon } from 'hugeicons-react';

export const QuotedContentDisplay: React.FC = () => {
  const { quotedContent, setQuotedContent } = useChatContext();

  if (!quotedContent) return null;

  return (
    <div className="quoted-content-display">
      <div className='quoted-content-icon'>
        <ArrowMoveDownRightIcon size={20} />
      </div>
      <div className="quoted-content-text">
        {quotedContent}
      </div>
      <button 
        type="button"
        className="quoted-content-close"
        onClick={() => setQuotedContent('')}
        aria-label="Remove quoted content"
      >
        <Cancel01Icon size={16} />
      </button>
    </div>
  );
};